import { render, staticRenderFns } from "./SharedItemsBrowser.vue?vue&type=template&id=45eb0e2b&scoped=true"
import script from "./SharedItemsBrowser.vue?vue&type=script&lang=js"
export * from "./SharedItemsBrowser.vue?vue&type=script&lang=js"
import style0 from "./SharedItemsBrowser.vue?vue&type=style&index=0&id=45eb0e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb0e2b",
  null
  
)

export default component.exports